import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/provider-actions';
import { ProviderActions } from '../constants';
import { IProvider } from 'src/types/provider';

export interface ProviderState {
    inProgress: boolean;
    inProgressCSV: boolean;
    authCode: string;
    error: string;
    data: Paginated<IProvider>;
    supervisorProviders: Paginated<Partial<IProvider>>;
    miniLoaderFor: { [key: string]: boolean };
    current: IProvider | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    inProgressCSV: false,
    authCode: '',
    error: '',
    miniLoaderFor: {},
    data: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    },
    supervisorProviders: {
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
        inProgress: false,
    },
    current: null,
    currentFiles: null,
};

export function providers(state: ProviderState = initialState, action: Actions | any): ProviderState {
    switch (action.type) {
        case requestType(ProviderActions.STAFF_FETCH_PROVIDERS_CSV):
            return { ...state, inProgressCSV: true };
        case successType(ProviderActions.STAFF_FETCH_PROVIDERS_CSV):
            return { ...state, inProgressCSV: false };
        case failureType(ProviderActions.STAFF_FETCH_PROVIDERS_CSV):
            return { ...state, inProgressCSV: false };
        case requestType(ProviderActions.STAFF_PERSIST_PROVIDER):
            return { ...state, error: '', inProgress: true };
        case successType(ProviderActions.STAFF_PERSIST_PROVIDER):
            return { ...state, inProgress: false };
        case failureType(ProviderActions.STAFF_PERSIST_PROVIDER):
            return { ...state, error: action.error, inProgress: false };

        case requestType(ProviderActions.STAFF_FETCH_SUPERVISOR_PROVIDERS):
            return {
                ...state,
                supervisorProviders: {
                    ...state.supervisorProviders,
                    list: [],
                    meta: state.supervisorProviders?.meta,
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(ProviderActions.STAFF_FETCH_SUPERVISOR_PROVIDERS):
            return { ...state, supervisorProviders: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(ProviderActions.STAFF_FETCH_SUPERVISOR_PROVIDERS):
            return {
                ...state,
                supervisorProviders: { ...state.supervisorProviders, inProgress: false },
                error: action.error,
                inProgress: false,
            };
        case requestType(ProviderActions.STAFF_FETCH_PROVIDERS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(ProviderActions.STAFF_FETCH_PROVIDERS):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(ProviderActions.STAFF_FETCH_PROVIDERS):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(ProviderActions.STAFF_FETCH_PROVIDERS_CONFIRMED_METRICS):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(ProviderActions.STAFF_FETCH_PROVIDERS_CONFIRMED_METRICS):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(ProviderActions.STAFF_FETCH_PROVIDERS_CONFIRMED_METRICS):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(ProviderActions.STAFF_FETCH_PROVIDERS_SMALL):
            return {
                ...state,
                data: {
                    ...state.data,
                    list: [],
                    meta: state.data?.meta,
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };
        case successType(ProviderActions.STAFF_FETCH_PROVIDERS_SMALL):
            return { ...state, data: { ...action.payload, inProgress: false }, inProgress: false };
        case failureType(ProviderActions.STAFF_FETCH_PROVIDERS_SMALL):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };
        case requestType(ProviderActions.STAFF_FETCH_PROVIDER):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(ProviderActions.STAFF_FETCH_PROVIDER):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(ProviderActions.STAFF_FETCH_PROVIDER):
            return { ...state, inProgress: false, error: action.error };

        case requestType(ProviderActions.STAFF_DELETE_PROVIDER):
            return { ...state, error: '', inProgress: true };
        case successType(ProviderActions.STAFF_DELETE_PROVIDER):
            state.data.list.forEach((user: IProvider, k, array) => {
                if (user.id === action.payload.id) {
                    array[k] = { ...array[k], status: 2 };
                    state.data.list.splice(k, 1);
                }
            });
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list,
                    meta: {
                        updatedAt: 0,
                    },
                },
            };

        case failureType(ProviderActions.STAFF_DELETE_PROVIDER):
            return { ...state, inProgress: false, error: action.error.response?.data?.errorMessage ?? 'Unknown error' };

        case successType(ProviderActions.STAFF_UPDATE_PROVIDER):
            state.data.list.forEach((user: IProvider, k, array) => {
                if (user.id === action.payload.userId) {
                    array[k] = { ...array[k], status: action.payload.status };
                }
            });
            return {
                ...state,
                data: {
                    ...state.data,
                    list: state.data.list,
                    meta: state.data.meta,
                },
            };
        case failureType(ProviderActions.STAFF_UPDATE_PROVIDER):
            return {
                ...state,
                error: action?.error ?? 'Unknown error',
                miniLoaderFor: {},
                inProgress: false,
            };
        case requestType(ProviderActions.STAFF_FETCH_FILES_PROVIDER):
            return { ...state, error: '', miniLoaderFor: { FILE: true } };
        case successType(ProviderActions.STAFF_FETCH_FILES_PROVIDER):
            return { ...state, miniLoaderFor: {}, currentFiles: action.payload };
        case failureType(ProviderActions.STAFF_FETCH_FILES_PROVIDER):
            return { ...state, miniLoaderFor: {}, error: action.error };
        case requestType(ProviderActions.STAFF_DELETE_FILE_PROVIDER):
            return { ...state, error: '', miniLoaderFor: { FILE: true } };
        case successType(ProviderActions.STAFF_DELETE_FILE_PROVIDER):
            const { sagaPayload } = action;
            const curNewFiles = (state.currentFiles ?? []).filter((file: any) => file.id !== sagaPayload.id);

            return {
                ...state,
                miniLoaderFor: {},
                currentFiles: curNewFiles,
            };
        case failureType(ProviderActions.STAFF_DELETE_FILE_PROVIDER):
            return { ...state, miniLoaderFor: {}, error: action.error.response.data?.errorMessage ?? 'Unknown error' };

        case requestType(ProviderActions.STAFF_CREATE_FILES_PROVIDER):
            return { ...state, error: '', miniLoaderFor: { FILE: true } };

        case successType(ProviderActions.STAFF_CREATE_FILES_PROVIDER_TYPE):
            if (action.payload.requestType === 'SIGNDOC') {
                const currentNew: Partial<IProvider> = { ...state.current, ...action.payload.payload };

                return {
                    ...state,
                    miniLoaderFor: {},
                    current: currentNew,
                } as ProviderState;
            } else {
                const curFiles = [...(state.currentFiles ?? [])];
                curFiles.push(action.payload);

                return {
                    ...state,
                    miniLoaderFor: {},
                    currentFiles: curFiles,
                };
            }

        case failureType(ProviderActions.STAFF_CREATE_FILES_PROVIDER):
            return { ...state, miniLoaderFor: {}, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        default:
            return state;
    }
}
